import React,{useState,useEffect, use} from "react"
import { useLocation as location2 } from "wouter";
import post from '../post';
import Alert from "../components/Alert";
import {formatDate} from "../components/Utilities"
import cn from 'classnames';
const PointHistory = () => {
    const [location, navigate] = location2();
    const [data,setData]=useState(null);
    const [alert, setAlert] = useState({ isOpen: false, title: '', message: '' });
    const user_id = localStorage.getItem('token');
    if (!user_id) {
        navigate('/login');
    }
    useEffect(() => {
        const getData=async () => {
            const t=await post('puntosHistory',{},false);
            if(t.result){
                console.log(t.data)
                setData(t.data);
            }else{
                setAlert({ isOpen: true, title: 'Error', message: t.motive || 'Error de conexión. Intente nuevamente más tarde.',onClose:()=>{navigate('/')}   });
            }
          }
        getData();
      }, []);
    return (
        <div id="webcrumbs">
            <Alert isOpen={alert.isOpen} title={alert.title} message={alert.message} onClose={() => {alert.onClose?alert.onClose():setAlert({ ...alert, isOpen: false })  }} />

            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center">
                <div className="w-full max-w-3xl px-6 py-10">
                    <div className="absolute top-2 left-2">
                        <button className="flex items-center justify-center p-2 bg-white rounded-full shadow-sm border border-neutral-100 hover:bg-neutral-50 transition-all transform hover:scale-105 active:scale-95"
                            onClick={() => navigate('/')}
                        >
                            <span className="material-symbols-outlined text-neutral-700">arrow_back</span>
                        </button>
                    </div>
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all">
                            <span className="material-symbols-outlined text-white text-3xl">history</span>
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">Historial de Puntos</h1>
                        <p className="text-neutral-600 text-center">
                            Consulte sus últimas transacciones de puntos de fidelidad
                        </p>
                    </div>

                    {data && 
                        (data.length=== 0 ? (
                            <span className="text-neutral-500 text-center">No hay transacciones de puntos disponibles.</span>
                        ) : (
                    <div className="bg-white rounded-lg shadow-sm border border-neutral-100  mb-6 backdrop-blur-sm">
                        <div className="">
                            <div className=" max-h-[400px] overflow-y-auto pr-2">
                                {data.map((tx, index) => (
                                    <>
                                    <div key={"rtx" + index} 
                                    className={cn("flex items-center justify-between    border-neutral-100 hover:border-primary-200 hover:bg-primary-50/30 transition-all mb-2",index==0?'':'border-t')}>
                                        <div className="flex items-center justify-between p-4   transition-all">
                                            <div className="flex items-center space-x-4">
                                                {tx.tipo=='G'?(   <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                                                    <span className="material-symbols-outlined text-green-600">add_circle</span>
                                                </div>)
                                                :(<div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                                                    <span className="material-symbols-outlined text-red-600">remove_circle</span>
                                                </div>)
                                                }
                                                
                                                <div>
                                                    <p className="font-medium text-neutral-900">{tx.tipo=='G'?'Acumulación de puntos':'Canje de puntos'}</p>
                                                    <p className="text-xs text-neutral-500">{tx.comentario}</p>
                                                    <p className="text-xs text-neutral-400">{formatDate(tx.fc)}</p>
                                                </div>
                                            </div>
                                            {tx.tipo=='G'?   <p className="font-bold text-green-600">+{tx.puntos} pts</p>
                                            :   <p className="font-bold text-red-600">-{tx.puntos} pts</p>
                                            }
                                           
                                        </div>
                                    </div>
                                    </>
                                        ))}

                            </div>

                            {/*<div className="flex justify-center pt-4">
                                <button className="flex items-center justify-center px-4 py-2 text-primary-600 hover:text-primary-700 transition-colors">
                                    <span className="material-symbols-outlined text-sm mr-1">expand_more</span>
                                    Ver más transacciones
                                </button>
                            </div>*/}
                        </div>
                    </div>
                    ))}


                    <div className="flex justify-center space-x-4">
                        <button className="flex items-center justify-center px-4 py-2 bg-white border border-neutral-200 text-neutral-800 rounded-xl hover:bg-neutral-50 transition-all shadow-sm"
                            onClick={() => navigate('/')}
                        >
                            <span className="material-symbols-outlined text-sm mr-1">arrow_back</span>
                            Volver
                        </button>
                        <button className="flex items-center justify-center px-4 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 transition-all shadow-sm"
                            onClick={() => navigate('/ticketReg')}
                        >
                            <span className="material-symbols-outlined text-sm mr-1">add_circle</span>
                            Acumular puntos
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default PointHistory;